module.exports = __webpack_public_path__ + "static/img/top-tabs-title-pic3.c36e2fbc.png";